export default __webpack_public_path__ + "static/media/doctor.10d70f95.png";